import React, { Component } from 'react'
import { translate } from 'react-i18next'

class VCGmaps extends Component {
  render() {
    const width = 600
    const height = 450

    let iframe
    let buff
    if (this.props.link)
        buff = new Buffer(this.props.link, 'base64');
        iframe = buff.toString('ascii');
        iframe = decodeURIComponent(iframe);

    let src
    let matches
    let regex = /<iframe.*?src="(.*?)"/;
    
    if (iframe)
        matches = regex.exec(iframe);
        if(matches && matches[1])
            src = matches[1]

    if (src)
        return <div className="map-responsive"><iframe src={src} width={width} height={height} frameBorder="0" style={{border: 0}} allowFullScreen="" aria-hidden="false" tabIndex="0"></iframe></div>
    else 
        return null
    
    }
}

export default translate()(VCGmaps)


// WEBPACK FOOTER //
// ./src/components/VCGmaps.js